<script>
  export let show = false
  export let unsaved = false


  const buildEnableAlertsUrl = function () {
    return '/enable-alerts?continue=' + encodeURIComponent(location.href)
  }

  const closeDialog = function () {
    if (show) {
      show = false
    }
  }
</script>

{#if show}
  <div class="dialogLayer">
    <div class="dialog">
      <div class="header">Enable Alerts</div>
      <div class="body">
        <p>We need your permission to send you task alerts via Alias.</p>
        <p>You'll be redirected to Alias to approve the required permissions.</p>
        {#if unsaved}
          <p>Note that any unsaved changes will be lost.</p>
        {/if}
        <div class="actions">
          <span class="spacer"></span>
          <button on:click={closeDialog}>Cancel</button>
          <a class="buttonLike" href={buildEnableAlertsUrl()}>Enable</a>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  div.dialogLayer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    padding: 10px;

    background-color: #FFF8;
  }

  div.dialog {
    display: flex;
    flex-direction: column;

    min-width: 150px;
    max-width: 100%;

    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px #0004;
  }

  div.dialog .header {
    padding: 15px;
    border-bottom: 1px solid var(--border-color);

    font-weight: 500;
  }

  div.dialog .body {
    padding: 15px;
  }
  div.dialog .body p {
    margin-bottom: 15px;

    text-align: center;
  }

  div.dialog .actions {
    display: flex;
  }
  div.dialog .actions > button {
    margin-right: 15px;
  }

  @media only screen and (min-width: 450px) and (min-height: 550px) {
    div.dialogLayer {
      padding: 30px;
    }
    div.dialog {
      max-width: 400px;
    }
  }
</style>
